module.exports = __webpack_public_path__ + "static/img/08.02e8f72.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour2/08.jpg
// module id = vcqC
// module chunks = 0